import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import { CartItem } from '../cart/cart-item';
import { OrderConfirmationService } from './order-confirmation.service';
import { OrderConfirmationInfo } from './order-confirmation-info';
export class OrderConfirmationComponent {
/**
 * @param {?} location
 * @param {?} router
 * @param {?} orderConfirmationService
 */
constructor(
private location: Location,
private router: Router,
private orderConfirmationService: OrderConfirmationService
    ) {
    }
/**
 * @return {?}
 */
goHome(): void {
        this.orderConfirmationService.orderConfirmationInfo = new OrderConfirmationInfo();
        this.router.navigate(['/']);
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'my-order-confirmation',
    template: "<div class=\"cart\"> <h2>Order Confirmation</h2> <ul class=\"cart-items\"> <li *ngFor=\"let cartItem of orderConfirmationService.orderConfirmationInfo.cartItems\"> <span>{{cartItem.product.name}} ${{cartItem.product.price}} Qty:{{cartItem.quantity}} SubTotal:{{cartItem.quantity * cartItem.product.price}}</span> </li> </ul> <span style=\"font-weight:bold;font-style:italic\">Total Before Tax:{{orderConfirmationService.orderConfirmationInfo.total_before_tax}}</span><br/> <span style=\"font-weight:bold;font-style:italic\">Tax :{{orderConfirmationService.orderConfirmationInfo.sales_tax}}</span><br/> <span style=\"font-weight:bold;font-style:italic\">Total After Tax :{{orderConfirmationService.orderConfirmationInfo.total_after_tax}}</span><br/> <span style=\"font-weight:bold;font-style:italic\">Shipping :{{orderConfirmationService.orderConfirmationInfo.shipping_cost}}</span><br/> <span style=\"font-weight:bold;font-style:italic\">Grand Total :{{orderConfirmationService.orderConfirmationInfo.grand_total}}</span><br/> <button (click)=\"goHome()\">Home</button> </div>",
    styles: ["label { display: inline-block; width: 3em; margin: .5em 0; color: #607D8B; font-weight: bold; } button { margin-top: 20px; font-family: Arial; background-color: #eee; border: none; padding: 5px 10px; border-radius: 4px; cursor: pointer; cursor: hand; } button:hover { background-color: #cfd8dc; } button:disabled { background-color: #eee; color: #ccc; cursor: auto; } .selected { border: double; border-width: thick; } .cart-items { list-style-type: none; }"]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Location, },
{type: Router, },
{type: OrderConfirmationService, },
];
}

function OrderConfirmationComponent_tsickle_Closure_declarations() {
/** @type {?} */
OrderConfirmationComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OrderConfirmationComponent.ctorParameters;
/** @type {?} */
OrderConfirmationComponent.prototype.location;
/** @type {?} */
OrderConfirmationComponent.prototype.router;
/** @type {?} */
OrderConfirmationComponent.prototype.orderConfirmationService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
